import { QrIcon } from "assets/icons";
import { QRCodeCanvas } from "qrcode.react";
import { useTranslation } from "react-i18next";
import { Button } from "ui";

import { downloadInventoryBoxQr } from "../../../helpers";
import { InventoryBoxesQrsTableCellProps } from "../InventoryBoxesQrsTable.types";

import styles from "../InventoryBoxesQrsTable.module.scss";

const DownloadBtnCell = ({ boxQrItem }: InventoryBoxesQrsTableCellProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.qrsTable_btnCell}>
      <QRCodeCanvas
        value={boxQrItem.id}
        id={`qr-${boxQrItem.id}`}
        style={{ display: "none" }}
      />
      <Button
        title={`${t("Download QR")}`}
        className={styles.downloadBtn}
        icon={<QrIcon color="white" />}
        onClick={() => downloadInventoryBoxQr(boxQrItem.id)}
      />
    </div>
  );
};

export default DownloadBtnCell;
